export default "__VITE_ASSET__3fddd009__"